import React from "react";

import "./SolutionsList.scss";

export interface ISolutionsList {
  titulo: string;
  items: string;
  // items: {
  //   description: string;
  // }[];
}

const SolutionsList = (props: ISolutionsList) => {
  const { titulo, items } = props;
  return (
    <div className="m-solutions-list">
      <h2>{titulo}</h2>
      {/* <ol type="A">
        {items.map((item, key) => {
          <li key={key}>{item.description}</li>;
        })}
      </ol> */}
      <ol type="A">
         {/*<li>{items}</li>
         <li>
          Sensibilizar a productores y comercializadores de comida de que su
          fruto, aun con imperfecciones, podría ser la solución al hambre en
          algún hogar.
        </li>
        <li>
          Tener una red de personas empleadas y voluntarias para recolección de
          excedentes agrícolas en zonas rurales.
        </li>
        <li>
          Disponer de vehículos para recoger los alimentos de finca en finca y
          redistribuirlos.
        </li>
        <li>Priorizar las familias con inseguridad alimentaria.</li>
        <li>
          Vigilar que las donaciones lleguen realmente a estas familias
          priorizadas y que no sean comercializadas irregularmente
        </li>*/}
      </ol>
    </div>
  );
};

export default SolutionsList;
